var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 2,
    fill: "#1A1B1D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0005 6.3C13.0005 6.13431 13.1348 6 13.3005 6L17.7 6C17.8657 6 18 6.13431 18 6.3L18 10.7C18 10.8657 17.8657 11 17.7 11L13.3005 11C13.1348 11 13.0005 10.8657 13.0005 10.7L13.0005 6.3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0005 13.3C13.0005 13.1343 13.1348 13 13.3005 13L17.7 13C17.8657 13 18 13.1343 18 13.3L18 17.7C18 17.8657 17.8657 18 17.7 18L13.3005 18C13.1348 18 13.0005 17.8657 13.0005 17.7L13.0005 13.3Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00443 6.3C6.00443 6.13431 6.13875 6 6.30443 6L10.7039 6C10.8696 6 11.0039 6.13431 11.0039 6.3L11.0039 10.7C11.0039 10.8657 10.8696 11 10.7039 11L6.30443 11C6.13875 11 6.00443 10.8657 6.00443 10.7L6.00443 6.3Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00004 13.3C6.00004 13.1343 6.13435 13 6.30004 13L10.6995 13C10.8652 13 10.9995 13.1343 10.9995 13.3L10.9995 17.7C10.9995 17.8657 10.8652 18 10.6995 18L6.30004 18C6.13435 18 6.00004 17.8657 6.00004 17.7L6.00004 13.3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupView);
export default __webpack_public_path__ + "static/media/group-view.fdb3c7798ceb9ecbfc77fff7b8fea047.svg";
export { ForwardRef as ReactComponent };